import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { DatewiseEvents } from '../../../calendar/models/datewise-events';
import { DateUtils } from '../../../../../utils/date-utils';
import { SchoolEvent } from '../../../calendar/models/school-event';
import { SwiperConfigInterface, SwiperScrollbarInterface } from 'ngx-swiper-wrapper';
import { MobileDashboardScrollBottomService } from '../../services/mobile-dashboard-scroll-bottom-service/mobile-dashboard-scroll-bottom.service';
import { ComponentBase } from '../../../../../base-classes/componet-base';

@Component({
  selector: 'app-mobile-daily-summary',
  templateUrl: './mobile-daily-summary.component.html',
  styleUrls: ['./mobile-daily-summary.component.scss']
})
export class MobileDailySummaryComponent extends ComponentBase implements OnInit {

  todaysdate: string = new Date().toISOString().split('T')[0];
  oneDay: number = 24 * 60 * 60 * 1000;
  timetable: Array<SchoolEvent>;
  platform: string;
  activeSlide: number = 0;
  overFlowY: string = 'hidden'
  @Input() selectedDay: DatewiseEvents;
  @ViewChild('swiperWrapper', { static: true }) public swiperWrapper: any;

  private scrollbar: SwiperScrollbarInterface = {
    el: '.swiper-scrollbar',
    hide: false,
  };

  public config: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 1,
    scrollbar: this.scrollbar,
  };

  constructor(private mobileDashboardScrollBottomService: MobileDashboardScrollBottomService) {
    super();
  }

  ngOnInit() {
    let sub = this.mobileDashboardScrollBottomService.subscribeScrollBottom().subscribe(res => {
      if (res == true) {
        this.overFlowY = 'auto';
      }
      else {
        this.overFlowY = 'hidden';
      }
    });
    this.addSubscription(sub);
  }

  ngOnChanges() {
    if (this.selectedDay) {
      this.timetable = [];
      this.selectedDay.time_table.forEach(tt => {
        this.selectedDay.homeworks_to_be_submitted.forEach(hw => {
          if (tt.title.includes(hw.subject_title)) {
            tt.hasHomeWork = true;
          }
        });
        this.timetable.push(tt);
      });
    }
  }

  isToday(date: string) {
    return this.todaysdate == date.split('T')[0];
  }

  findDifferenceInDays(date: string) {
    let firstDate = DateUtils.parseDateAndTime(date.split('T')[0]);
    let secondDate = DateUtils.parseDateAndTime(this.todaysdate);
    return Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / (this.oneDay)));
  }

  ttLnkClicked() {
    this.swiperWrapper.directiveRef.instance.slideTo(0);
  }

  eventLnkClicked() {
    this.swiperWrapper.directiveRef.instance.slideTo(1);
  }

  onSwipe(index: number) {
    this.activeSlide = index;
  }

}
